import { onCleanup, onMount } from "solid-js";
import type { SignalModule } from "../../enums/scan";
import type { WebsiteContext } from "../website/store";
import { ScanBrand } from "./ScanBrand";
import { ScanPrimaryNavigation } from "./ScanPrimaryNavigation";
import { ScanRunControls } from "./ScanRunControls";
import { ScanWorkspaceMenus } from "./ScanWorkspaceMenus";

export function ScanTopBar(props: {
  context: WebsiteContext;
  activeModule: SignalModule | "none";
}) {
  let header: HTMLElement | undefined;
  onMount(() => {
    const element = header;
    const app = element?.parentElement;
    if (!element || !app) return;
    const observer = new ResizeObserver(() => {
      app.style.setProperty(
        "--signal-header-height",
        `${element.offsetHeight}px`,
      );
    });
    observer.observe(element);
    onCleanup(() => observer.disconnect());
  });
  return (
    <header ref={header} class="signal-topbar">
      <ScanBrand href={`/w/${props.context.websiteId}/overview`} />
      <ScanPrimaryNavigation
        websiteId={props.context.websiteId}
        activeModule={props.activeModule}
      />
      <ScanRunControls context={props.context} />
      <ScanWorkspaceMenus
        context={props.context}
        activeModule={props.activeModule}
      />
    </header>
  );
}
